/* global fetch, Headers */
import 'isomorphic-fetch'
import MockJSON from './mock'
import cloneDeep from 'lodash/cloneDeep'
import { TabMap } from '../components/common/TabNavigation'

export const SUMMARY_TAB_ENABLED = 'SUMMARY_TAB_ENABLED'
export const SUMMARY_EMAIL_STATUS = 'SUMMARY_EMAIL_STATUS'
export const SUMMARY_EMAIL_STATUS__LOADING = 'SUMMARY_EMAIL_STATUS__LOADING'
export const MAP_LOADED = 'MAP_LOADED'
export const LIKERT_RESPONSE = 'LIKERT_RESPONSE'
export const OPINION_RESPONSE = 'OPINION_RESPONSE'
export const QUIZ_RESPONSE = 'QUIZ_RESPONSE'
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
export const JWT_REFRESH = 'JWT_REFRESH'
export const SET_VISITED_NAV = 'SET_VISITED_NAV'

export function loadMap (mapId) {
  return (dispatch, getState) => {
    const { serviceInfo, prescriptionInfo } = getState()
    
    let sendDispatch = json => {
      json.navigationInfo = json.data.navigation.topics.map((topic, index) => { return Object.assign(topic, { 'tab': TabMap[index] }) })
      json.data.applicationUrl = (prescriptionInfo && prescriptionInfo.applicationUrl) || hwPreloadedState.prescriptionInfo.applicationUrl

      dispatch(mapLoaded(json))
    }

    if (serviceInfo.isMocked) {
      let json = {}
      json.data = MockJSON

      sendDispatch(json)
    } else {
      const servicePath = serviceInfo.contentServiceUrl + `/articles/${mapId.toUpperCase()}/${prescriptionInfo.localization}`

      var headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + serviceInfo.token
      })

      fetch(servicePath, {
        headers: headers,
        mode: 'cors'
      }).then(response => {
        if (response.status >= 400) {
          throw new Error(`Bad response from server: ${response.status}`)
        }

        return response.json().then(json => {
          sendDispatch(json)
        })
      }).catch(error => { console.error(`Request failed: ${error}`) })
    }
  }
}

export function enableSummary () {
  return (dispatch, getState) => {
    dispatch({type: SUMMARY_TAB_ENABLED, enabled: true})
  }
}

export function updateStatus (newStatus) {
  return (dispatch, getState) => {
    const { serviceInfo, prescriptionInfo } = getState()

    // for pass-through demo usage, there is no prescriptionID, so we don't want to send status
    if (prescriptionInfo.prescriptionId.length && !serviceInfo.isMocked) {
      getRequestToConsumerService(serviceInfo, prescriptionInfo, 'status')
        .then(function (json) {
          if (json.status >= 400) {
            console.error(json)
            throw new Error(`Bad response from server: ${json.status} - ${json.type} - ${json.statusText}`)
          }

          let shouldUpdate = false
          switch (json.data.statusName) {
            case 'No-Activity':
              // Nothing has been set, yet, so we're good to go.
              shouldUpdate = true
              break
            case 'In-Progress':
              if (newStatus === 'Partial' || newStatus === 'Completed') {
                shouldUpdate = true
              }
              break
            case 'Partial':
            case 'Completed':
              // Partial and Completed are status endpoints.  We should not update beyond this.
              break
            default:
              break
          }

          if (shouldUpdate) {
            postRequestToConsumerService(serviceInfo, prescriptionInfo, {
              status: newStatus,
              timestamp: (new Date()).toISOString()
            }, 'status')
          }
        })
        .catch(function (err) {
          console.error(`Error retrieving status: ${err}`)
        })
    }
  }
}

export function updateResponses (eventName, data) {
  return (dispatch, getState) => {
    const { responseState, serviceInfo, prescriptionInfo } = getState()
    const newResponseState = cloneDeep(responseState)

    if (data.id && data.answerId) {
      let responseSequenceNumber = 1

      if (newResponseState.responses && newResponseState.responses[data.id]) {
        responseSequenceNumber = newResponseState.responses[data.id].answer.responseSequenceNumber + 1
      }

      newResponseState.responses[data.id] = {
        'sequenceNumber': sequenceNumber,
        'timestamp': (new Date()).toISOString(),
        'questionId': data.id,
        'locale': prescriptionInfo.localization,
        'type': data.type,
        'answer': {
          'id': data.answerId,
          'responseSequenceNumber': responseSequenceNumber,
          'value': (data.answers || []).reduce((prev, curr) => curr.id === data.answerId ? curr.answer : prev, '')
        }
      }

      // iterate sequence number after each answer (hint: doing this here, since the calls are async)
      sequenceNumber++
    }

    const response = newResponseState.responses[data.id]
    const responses = newResponseState.responses

    switch (eventName) {
      case 'LikertResponse':
        postRequestToConsumerService(serviceInfo, prescriptionInfo, response)
        // dispatch immediately, since we don't have a failure mode
        dispatch({type: LIKERT_RESPONSE, responses})

        break

      case 'OpinionResponse':
        postRequestToConsumerService(serviceInfo, prescriptionInfo, response)
        dispatch({type: OPINION_RESPONSE, responses})

        break

      case 'QuizResponse':
        if (response && response.answer && response.answer.responseSequenceNumber === 1) {
          postRequestToConsumerService(serviceInfo, prescriptionInfo, response)
        }
        dispatch({type: QUIZ_RESPONSE, responses})

        break
    }
  }
}

// counter to track which answer we're on (handled here, since the Redux store value could be behind, based on async calls)
let sequenceNumber = 0

function postRequestToConsumerService (serviceInfo, prescriptionInfo, response, endPoint = 'responses') {
  // for pass-through demo usage, there is no prescriptionID, so we don't want to send status
  if (prescriptionInfo.prescriptionId.length && !serviceInfo.isMocked) {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + serviceInfo.token
    })

    const url = `${serviceInfo.consumerServiceUrl}/consumers/${prescriptionInfo.consumerId}` +
      `/messages/${prescriptionInfo.prescriptionId}/items/${prescriptionInfo.contentItemId}` +
      `/${prescriptionInfo.localization}/${endPoint}`

    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'post',
        headers: headers,
        mode: 'cors',
        body: JSON.stringify(response)
      })
      .then(res => {
        return res.json()
      })
      .then(data => {
        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
    })
  }
}

function getRequestToConsumerService (serviceInfo, prescriptionInfo, endPoint = 'responses') {
  if (!serviceInfo.isMocked) {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + serviceInfo.token
    })

    const url = `${serviceInfo.consumerServiceUrl}/consumers/${prescriptionInfo.consumerId}` +
      `/messages/${prescriptionInfo.prescriptionId}/items/${prescriptionInfo.contentItemId}` +
      `/${prescriptionInfo.localization}/${endPoint}`

    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'get',
        headers: headers,
        mode: 'cors'
      })
      .then(res => {
        return res.json()
      })
      .then(data => {
        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
    })
  }
}

export function emailEsdpSummary (emailJSON) {
  return (dispatch, getState) => {
    const services = getState().serviceInfo

    emailJSON.headerText = ''
    emailJSON.emailMessage = ''
    emailJSON.legalMessage = '<p>This information does not replace the advice of a doctor. Healthwise, Incorporated, disclaims any warranty or liability for your use of this information.<span> Your use of this information means that you agree to the <a target="_blank" href="https://www.healthwise.org/specialpages/legal/terms.aspx"><!-- react-text: 1466 -->Terms of Use<!-- /react-text --></a> and <a target="_blank" href="https://www.healthwise.org/specialpages/legal/privacy.aspx">Privacy Policy</a>.</span></p><p>To learn more about Healthwise, visit <a target="_blank" href="https://www.healthwise.org">Healthwise.org</a>.</p><p>© 1995-2021 Healthwise, Incorporated. Healthwise, Healthwise for every health decision, and the Healthwise logo are trademarks of Healthwise, Incorporated.</p>'

    // get the email template
    fetch(
      services.atomicFireballServiceUrl + '/email/esdp',
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(emailJSON)
      }
    )
    .then(response => {
      if (response.status < 400) {
        return response.text()
      }
      throw new Error('Unable to send email.')
    })
    .then(emailHTML => {
      dispatch(setSummaryEmailStatus(SUMMARY_EMAIL_STATUS__LOADING))

      const body = {
        to: emailJSON.to,
        from: 'noreply@healthwise.org',
        subject: emailJSON.subject,
        body: emailHTML,
        resources: emailJSON.resources
      }

      // send the email template to the notification service
      fetch(
        services.notificationServiceUrl + '/email',
        {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + services.token
          },
          body: JSON.stringify(body)
        }
      )
      .then(response => {
        if (response.status < 400) {
          return response.text()
        }
        throw new Error('Unable to send email.')
      })
      .then(
        () => {
          dispatch(setSummaryEmailStatus(true))
        },
        err => {
          console.error(err)
          dispatch(setSummaryEmailStatus(false))
        }
      )
    })
    .catch(err => {
      console.error(err)
      dispatch(setSummaryEmailStatus(false))
    })
  }
}

export function updateJWT () {
  return (dispatch, getState) => {
    if (!serviceInfo.isMocked) {
      fetch(getState().prescriptionInfo.applicationUrl + '/client/token', { credentials: 'same-origin' })
        .then(function (res) {
          res.json().then(function (data) {
            dispatch(jwtUpdated(data.token))
          })
        })
        .catch(function (err) {
          console.error(err)
        })
    }
  }
}

export function setVisitedNav (id) {
  return {
    type: SET_VISITED_NAV,
    id: id
  }
}

// 'status' can be:
// - true: successfully sent
// - false: error on send
// - null: no active status
export function setSummaryEmailStatus (status) {
  return {
    type: SUMMARY_EMAIL_STATUS,
    status: status
  }
}

function jwtUpdated (token) {
  return {
    type: JWT_REFRESH,
    token: token
  }
}

function mapLoaded (json) {
  return {
    type: MAP_LOADED,
    mapData: json
  }
}



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/actions/index.js